import React from "react";
import { useAuth } from "../../common/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import logo from "../../common/assets/gfps-logo.png";
import { Container, Navbar, Nav, NavDropdown, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import Flag from "react-world-flags";
import "./Header.scss";
import { useLang } from "../../common/hooks/useLang";
import { useTranslation } from "react-i18next";
import { useToken } from "../../common/hooks/useToken";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";

export default function Header(props) {
  const auth = useAuth();
  const { accessToken } = useToken();
  const navigate = useNavigate();
  const { currentLanguage, setCurrentLanguage, isLanguageDisabled } = useLang();
  const { t } = useTranslation(NAMESPACE_REMOTE);

  const handleLogout = () => {
    auth.logout();
    navigate("/login", { replace: true });
  };

  const handleHome = () => {
    navigate("/home", { replace: true });
  };

  const getUserInitials = (username) => {
    let result = "";

    if (username) {
      let subnames = username.split(" ");
      if (subnames.length >= 2) {
        // [F]irstname + [L]astname
        result = subnames[0].charAt(0) + subnames[subnames.length - 1].charAt(0);
      } else if (subnames.length >= 1) {
        // [L]astname
        result = subnames[0].charAt(0);
      }
    }

    return result;
  };

  return (
    <Navbar bg="dark" variant="dark" sticky="top">
      <Container fluid>
        <Navbar.Brand role="button" onClick={handleHome}>
          <img src={logo} height="57" alt="GfPS" title="GfPS" />
        </Navbar.Brand>
        <Navbar.Text>{props.title}</Navbar.Text>
        <Nav
          className="align-items-end"
          >
          <NavDropdown
            id="nav-dropdown"
            className="btn-primary rounded-circle text-center p-0"
            style={{ width: "42px", height: "42px" }}
            drop="down"
            align="end"
            menuVariant="dark"
            title={
              <>
                {getUserInitials(accessToken.decodedToken.given_name)}
              </>
            }
          >
            <NavDropdown.Header>
              {accessToken.decodedToken.given_name}
            </NavDropdown.Header>
            <NavDropdown.Divider />
            <Nav className="align-items-end">
              <NavDropdown disabled={isLanguageDisabled}
                className="w-100"
                title={
                  <>
                    <Flag
                      code={currentLanguage === "en" ? "gb" : currentLanguage}
                      width="24"
                      className="align-baseline"
                    />&nbsp;
                    {t("PROMPT.WSHOP2.HEADER.LANGUAGE")}
                  </>
                }
              >
                <Stack direction="horizontal">
                  <NavDropdown.Item className="d-inline text-center" onClick={() => setCurrentLanguage("de")}>
                    <Flag code="de" width="24" />
                  </NavDropdown.Item>
                  <div className="vr"></div>
                  <NavDropdown.Item className="d-inline text-center" onClick={() => setCurrentLanguage("en")}>
                    <Flag code="gb" width="24" />
                  </NavDropdown.Item>
                </Stack>
              </NavDropdown>
            </Nav>

            <NavDropdown.Item onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} className="me-1" />
              {t("PROMPT.WSHOP2.HEADER.LOGOUT")}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Container>
    </Navbar>
  );
}
